export default class RequestError extends Error {
  constructor(nativeError, request, response, data) {
    super(nativeError.message)
    Object.defineProperties(this, {
      name: {
        enumerable: false,
        value: `Request error`,
      },
      request: {
        enumerable: false,
        value: request,
      },
      response: {
        enumerable: false,
        value: response,
      },
      data: {
        enumerable: true,
        value: data,
      },
    })
  }
}
